export const FORM_SECTION_ROUTES = {
    FORMS: "forms",
    CREATENEW: "createnew",
    IMPORT: "import",
    SUCCESS: "success",
    LISTING: "listing",
    RECONCILIATION: "reconciliation",
    MANAGE: "manage",
    IRSSTATEREJECTED: "irsstaterejected",
    SUBMITRECONCILIATION: "submitreconciliation",
    REVIEW_AND_APPROVE_FORMS: "reviewandapprove",
    REVIEW_REJECTED_FORMS: "reviewrejectedforms",
    FEDERALFORMS: "federalforms",
    MANAGE_STATE_FORMS: "stateforms",
    EXTENSIONFORMS: 'manageextensionform',
    IRST_STATE_REJECTED_FEDERAL_RESUBMIT: "federalresubmit",
    SUBMIT:"submit",
    FORM1099:"form1099",
    STATEPAYROLL: "statepayroll",
    STATE_PAYROLL_FORMS: "statepayrollforms"
};

export const QUERY_PARAMS = {
    REFERENCE_ID: "ReferenceId",
    FORM_ID: "FormId",
    FORM_NAME: "FormName",
    PAYER_ID: "PayerId",
    STATE_ID: "StateId",
    TAX_YEAR: "TaxYear",
    YEAR: "Year",
    STATUS: "Status",
    PAYER_NAME: "PayerName",
    RECIPIENT_NAME: "RecipientName",
    RECIPIENT_ID: "RecipientId",
    RECIPIENT_EMAIL: "RecipientEmail",
    TIN_STATUS: "TINStatus",
    IS_ACTIVE: "IsActive",
    W8_W9_STATUS: "W8W9Status",
    IS_TIN_REQUESTED: "IsTinRequested",
    FROM: "From",
    TO: "To",
    PAGE: "page",
    ALLOW_PAYER_RECIPIENT_SELECTION: "allowpayerselection",
    STATENAME: "StateName",
    PAYROLL: "Payroll",
    FORM_RECORD_ID: "FormRecordId",
};

export const QUERY_PARAMS_VALUE = {
    CORRECTED: "Corrected",
}

export const CURRENT_FORM_CREATION_MODULE = {
    SINGLE: "Single",
    BATCH: "Batch",
};

export const FORM_IDS = {
    $1095C: 30,
    8809: 0,
    $1099NEC: 47,
    $1099MISC: 1,
}

export const FORM_NAMES = {
    FORM1042S: "Form1042S",
    FORM1095B: "Form1095B",
}

export const TIN_STATUS = {
    NOT_SUBMITTED: "Not Submitted",
    REJECTED: "Rejected",
    BLOCKED: "Blocked",
    PROCESSING: "Processing"
}

export const VIEW_TIN_CHECKBOX_MESSAGE = "If this checkbox is selected it will show the TINs of all recipients in the info grid below and if a PDF download is requested, recipient TINs will be unmasked there as well."

export const EDIT_FORM_ORIGIN = "editformorigin"

export const FORM_SECTION_CONSTANTS = {
    SUBMIT_FORMS: "SubmitForms"
}

export const USER_ALLOWED_FEATURES = {
    SUBMIT_FOR_MULTIPLE_PAYER: [3, 4]
}